<div class="header-navigation" >
  <span>Trips</span>
</div>
@if (!loading) {
  <div>
    <div class="margin-top-md margin-left-sm padding-bottom-sm title-header">Ongoing</div>
    <mat-divider></mat-divider>
    @if (ongoingShipment) {
      <app-shipment-item
        (click)="onNavigateToLoadDetails(ongoingShipment.id)"
        [shipment]="ongoingShipment"
        [driverId]="driverId"
        >
      </app-shipment-item>
      <mat-divider class="list-item-seperator"></mat-divider>
    }
    @if (!ongoingShipment) {
      <app-no-shipment [message]="noShipment"> </app-no-shipment>
    }
    <div class="margin-top-md margin-left-sm padding-bottom-sm title-header">
      Up coming <span>({{ upcomingShipmentCount }})</span>
    </div>
    <mat-divider></mat-divider>
    @if (upcomingShipment) {
      @for (shipment of upcomingShipment; track shipment) {
        <div>
          <app-shipment-item
            (click)="onNavigateToLoadDetails(shipment.id)"
            [shipment]="shipment"
            [driverId]="driverId"
            [isTrip]="true"
            >
          </app-shipment-item>
          <mat-divider class="list-item-seperator"></mat-divider>
        </div>
      }
    }
    @if (!upcomingShipment) {
      <app-no-shipment [message]="noShipment"> </app-no-shipment>
    }
  </div>
}
